export const isMobile = () => {
  return document.body.classList.contains('mobile');
};
